import { Component, ElementRef } from '@angular/core';
import { PageBase } from 't4core';
@Component({
  styleUrls: ['./FuturePickups.component.css'],
  selector: 'FuturePickups',
  templateUrl: './FuturePickups.component.html',
})
export class FuturePickupsComponent extends PageBase {
  constructor(el: ElementRef) {
    super(el, "OnewayFuturePickupReport");
  }
}
